import React from 'react';
export function PhilosophySection() {
  return <section className="bg-white flex flex-col-reverse lg:flex-row overflow-hidden" data-id="element-140">
      {/* Content Side */}
      <div className="w-full lg:w-1/2 py-[60px] md:py-[80px] lg:py-[120px] px-6 md:px-12 lg:px-20 flex flex-col justify-center" data-id="element-141">
        <span className="text-label mb-6" data-id="element-142">Our Philosophy</span>

        <h2 className="md:text-section-tablet lg:text-section-desktop text-charcoal mb-8 font-[500]" data-id="element-143">
          Meticulous Viticulture, Artisanal Winemaking
        </h2>

        <div className="space-y-6 text-body text-charcoal" data-id="element-144">
          <p data-id="element-145">
            At Glenlofty, our philosophy is simple: to create wines that are a
            pure and authentic expression of our unique terroir. We practice
            meticulous, sustainable viticulture focused on soil health, vine
            balance, and low yields. By nurturing the vineyard, we grow fruit of
            exceptional quality and character.
          </p>
          <p data-id="element-146">
            In the winery, our approach is one of minimal intervention.
            Traditional, artisanal techniques guide the wines from grape to
            glass, allowing the vineyard to speak clearly. Wild fermentations,
            gentle handling, and maturation in fine French oak contribute to
            wines of elegance, complexity, and longevity.
          </p>
        </div>
      </div>

      {/* Image Side */}
      <div className="w-full lg:w-1/2 h-[400px] lg:h-auto relative" data-id="element-147">
        <img src="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/Homepage_5_Maturation.jpg" alt="Wine maturation at Glenlofty" className="w-full h-full object-cover" data-id="element-148" />
      </div>
    </section>;
}